module.exports = __webpack_public_path__ + "static/media/trip-5.edcce087.png";